export function getView(thread_type, is_secure) {
  return thread_type === 'in_app' && !is_secure ? 'InApp' : 'No'
}
